var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',[_c('p',[_vm._v(" wiadomość: "+_vm._s(_vm.form.tasks_data['CREATE_REQUEST']['input']['contact_message_id'])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }